import React from 'react';

export default function Fullscreen({ children }) {
  document.body.className= "bg-default";

  return (
  <div className="">
    <div className="header bg-gradient-primary py-7 py-lg-8">
      <div className="container">
        <div className="header-body text-center mb-7">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6">
              <h1 className="text-white">iHub</h1>
              <p className="text-lead text-light">
                iHub Dashboard is a visualization tool for Process Control.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon className="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    { children }
    <footer className="py-5">
      <div className="container">
        <div className="row align-items-center justify-content-xl-between">
          <div className="col-xl-6">
            <div className="copyright text-center text-xl-left text-muted">
              <a href="https://www.flashtech.nl/over-ons/ihub" className="font-weight-bold ml-1">
                iHub Dashboard
              </a>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="text-center text-xl-right text-muted">
               +31 (0) 6 34 34 73 65
               <a href="mailto:info@flashtech.nl" className="font-weight-bold ml-1">
                 info@flashtech.nl
               </a>
               - powered by Flashtech
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
  );
}